import React from 'react';
import Facetune1 from '../assets/images/Facetune1.jpeg';
import Facetune2 from '../assets/images/Facetune2.jpeg';
import Facetune3 from '../assets/images/Facetune3.jpeg';
import Facetune4 from '../assets/images/Facetune4.jpeg';

const Gallery = () => {
  const galleryItems = [
    Facetune1,
    Facetune2,
    Facetune3,
    Facetune4
  ];

  return (
    <section className="gallery">
      <div className="container">
        <div className="gallery-grid">
          {galleryItems.map((img, index) => (
            <div key={index} className="gallery-item">
              <img 
                src={img} 
                alt={`Trabalho de Sobrancelhas ${index + 1}`}
              />
            </div>
          ))}
        </div>        
      </div>
    </section>
  );
};

export default Gallery;

